/* eslint-disable camelcase */
export default {
  namespaced: true,

  state: {
    isIframe: false,
    info: {
      clientHeight: 0,
      clientWidth: 0,
      iframeHeight: 0,
      iframeWidth: 0,
      offsetLeft: 0,
      offsetTop: 0,
      scrollLeft: 0,
      scrollTop: 0
    }
  },

  mutations: {
    setInfo (state, info) {
      state.info = Object.assign({}, state.info, info)
    },
    setisIframe (state, isIframe) {
      state.isIframe = isIframe
    }
  },

  getters: {
    getFrameInfo: state => {
      return state.info
    }
  },

  actions: {
    syncIframeInfo ({ commit, dispatch }) {
      if ('parentIFrame' in window) {
        window.parentIFrame.getPageInfo(function (data) {
          commit('setInfo', data)
        })
        commit('setisIframe', true)
      } else {
        requestAnimationFrame(function () {
          dispatch('syncIframeInfo')
        })
      }
    }
  }
}
